import React from 'react';
import withIcon from '../utilities/withIcon';

const IconFolderUser = () => {
  return (
    <g>
      <path d="m15.1775 3.63h-7.0952l-1.3477-2.3458a.7506.7506 0 0 0 -.65-.376h-5.2621a.75.75 0 0 0 -.75.75v12.6836a.75.75 0 0 0 .75.75h14.355a.75.75 0 0 0 .75-.75v-9.9618a.75.75 0 0 0 -.75-.75zm-9.5275-1.2218.702 1.2218h-4.78v-1.2218zm8.7773 11.1836h-2.2115c-.1233-2.3251-1.1139-1.6335-2.5717-2.5808a.4166.4166 0 0 0 -.5413.0677l-.8774.8831a.3173.3173 0 0 1 -.45 0l-.8775-.8831a.4168.4168 0 0 0 -.5414-.0677c-1.4575.9473-2.4481.2557-2.5714 2.5808h-2.2126v-8.4618h12.855z" />
      <path d="m6.2872 7.0741c-.6124 1.3449.188 3.7421 1.7128 3.7421s2.3256-2.3972 1.7131-3.7421a1.8353 1.8353 0 0 0 -1.7131-1.0666 1.8353 1.8353 0 0 0 -1.7128 1.0666z" />
    </g>
  );
};

export default withIcon(IconFolderUser);
